module.exports = __webpack_public_path__ + "static/better-flag-1080w-090718-8378adb5011ffe31cfa1278fddf6b2a1.jpg";